var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100% !important"}},[_c('apexchart',{attrs:{"options":_vm.chartOptions,"height":_vm.resizeChartHeight(),"series":_vm.series}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }